import React from "react";
import { range } from "lodash";
import Kendra from "aws-sdk/clients/kendra";

import { PAGE_SIZE } from "../constants";
import "../search.scss";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

interface PaginationProps {
  queryText: string;
  currentPageNumber: number;
  onSubmit: (queryText: string, currentPageNumber: number) => void;
  results: Kendra.QueryResult;
}

// show a max of 7 pages centered at the current page
const NumberOfPreviousPagesToShow = 3;
const NumberOfNextPagesToShow = 4;

export default class Pagination extends React.Component<PaginationProps, {}> {
  
  // on page change callback to API call.
  onPageSelected = (selectedPageNumber: number) => () => {
    const { onSubmit } = this.props;
    onSubmit(this.props.queryText, selectedPageNumber);
  };

  renderNumber = (page: number) => {
    const { currentPageNumber } = this.props;
    return (
      <span
        className={
          page === currentPageNumber
            ? "active page-number action-link"
            : "page-number action-link"
        }
        key={page}
        onClick={this.onPageSelected(page)}
      >
        {page}
      </span>
    );
  };

  render() {
    const { currentPageNumber, results } = this.props;

    const pageCount = Math.ceil(results.TotalNumberOfResults! / PAGE_SIZE);

    const totalPages = () => {
      if (pageCount < 10) {
        return Math.ceil(results.TotalNumberOfResults! / PAGE_SIZE);
      } else {
        return 10
      }
    }

    const pagesToShow = range(
      Math.max(1, currentPageNumber - NumberOfPreviousPagesToShow),
      Math.min(totalPages(), currentPageNumber + NumberOfNextPagesToShow) + 1
    );

    const firstButton = currentPageNumber > NumberOfNextPagesToShow && (
      <span className="page-arrow" onClick={this.onPageSelected(1)}>
        <KeyboardDoubleArrowLeftIcon fontSize="small" />
      </span>
    );

    const lastButton = totalPages() - currentPageNumber > NumberOfNextPagesToShow && (
      <span className="page-arrow" onClick={this.onPageSelected(totalPages())}>
        <KeyboardDoubleArrowRightIcon fontSize="small" />
      </span>
    );

    const prevButton = currentPageNumber !== 1 && (
      <span className="page-arrow" onClick={this.onPageSelected(currentPageNumber - 1)}>
        <NavigateBeforeIcon fontSize="small" />
      </span>
    );

    const nextButton = currentPageNumber < totalPages() && (
      <span className="page-arrow" onClick={this.onPageSelected(currentPageNumber + 1)}>
        <NavigateNextIcon fontSize="small" />
      </span>
    );

    const forwardEllipsis = totalPages() - currentPageNumber >
      NumberOfNextPagesToShow && (
        <span className="page-ellipsis">…</span>
      );

    const backwardEllipsis = currentPageNumber > NumberOfNextPagesToShow && (
      <span className="page-ellipsis">…</span>
    );

    return (
      <div className="pagination-section">
        {firstButton}
        {prevButton}
        {backwardEllipsis}
        {pagesToShow.map(this.renderNumber)}
        {forwardEllipsis}
        {nextButton}
        {lastButton}
      </div>
    );
  }
}
